var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-top"},[_c('div',{staticClass:"chart-name"},[_vm._v(" 质量服务需求类别统计 "),_c('dv-decoration-1',{staticStyle:{"width":"200px","height":"20px"}}),_c('div',{staticClass:"chart-name-text"},[_vm._v("已提交需求调查问卷表总数："+_vm._s(_vm.count)+"（份）")])],1),_c('dv-capsule-chart',{staticStyle:{"height":"260px"},attrs:{"config":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }